import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import Color from '@tool/color';
import moWelfare from '../store';

interface IProps {}
interface IState {}

const HolidayTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { keyHolidayTable } = moWelfare;

  useEffect(() => {
    return () => {};
  }, []);

  const colorList = ['', Color.cf, Color.primary, Color.secondary];

  return (
    <section className="holiday-table-warp">
      <section>
        <section className="table-title">
          {['', '25分位', '50分位', '75分位'].map((res: any, i: any) => {
            return (
              <p key={i} style={{ background: colorList[i] }}>
                {res}
              </p>
            );
          })}
        </section>
        <section className="table-content">
          {keyHolidayTable?.map((res: any, i: any) => {
            return (
              <p key={i}>
                <span style={{ background: i === 0 ? Color.c333 : Color.c999 }}>
                  {res.festival}
                </span>
                <span>{res.fw_25?.toLocaleString()}</span>
                <span>{res.fw_50?.toLocaleString()}</span>
                <span>{res.fw_75?.toLocaleString()}</span>
              </p>
            );
          })}
        </section>
      </section>
    </section>
  );
};

export default observer(HolidayTable);
